import { ExaminationInfoQuery, Examination_Scoring_Type, Trial } from "@generated/graphql";
import dayjs from "dayjs";
import { normalizeAssessmentLevels } from "../view/components/resultAssessmentMode.utils";
import { getExaminationIsExtendedReport } from "../view/helpers";
import { CompetencyMapOptionList } from "../view/types";

type Examination = ExaminationInfoQuery["examination"];

// eslint-disable-next-line import/prefer-default-export
export const getTestingBaseFormData = (
  id?: string,
  trialOrExamination?: Partial<Trial | Examination>,
  competencyMap?: NonNullable<CompetencyMapOptionList>[number]
) => {
  const examination =
    trialOrExamination && "examination" in trialOrExamination
      ? trialOrExamination.examination
      : (trialOrExamination as Examination | undefined);
  const { createdAt } = trialOrExamination || {};
  const assessmentData = trialOrExamination as
    | Partial<{
        scoringType: Examination_Scoring_Type;
        gradeDeterminationMap: { from: number; to: number; label: string }[];
      }>
    | undefined;

  return {
    id: id || "",
    title: examination?.title,
    createdAt: createdAt ? dayjs(createdAt).format("DD.MM.YYYY HH:mm") : "",
    competencyMap: competencyMap
      ? {
          id: competencyMap?.id || "",
          title: competencyMap?.title || "",
        }
      : undefined,
    competencyMapComment: competencyMap?.comment || "",
    competencyMapGrades: competencyMap?.grades?.join(", ") || "",
    isSendResult: examination?.isSendResult === undefined ? true : examination.isSendResult,
    isExtendedReport: getExaminationIsExtendedReport(examination?.sendResultType),
    isInterview: examination?.isInterview || false,
    maxFollowups: String(examination?.maxFollowups ?? 2),
    threshold: examination?.threshold ?? 60,
    passingThreshold: examination?.passingThreshold ?? 40,
    scoringType: assessmentData?.scoringType || Examination_Scoring_Type.PassingThreshold,
    gradeDeterminationMap: normalizeAssessmentLevels(assessmentData?.gradeDeterminationMap),
    availableRange: {
      from: examination?.availableFrom || null,
      to: examination?.availableTo || null,
    },
  };
};
